import {OrganizationPrefix} from '../components/WorkspaceDrawer/Settings/types';

export const organizationPrefixIsLast = (
  autoOrganizePrefix?: OrganizationPrefix
) => autoOrganizePrefix === OrganizationPrefix.LastPrefix;

export function getPrefixSectionName(
  metric: string,
  autoOrganizePrefix?: OrganizationPrefix
): string | null {
  const sepPos = organizationPrefixIsLast(autoOrganizePrefix)
    ? metric.lastIndexOf('/')
    : metric.indexOf('/');
  if (sepPos === -1) {
    return null;
  }
  return metric.slice(0, sepPos);
}
